<template>
  <a-row class="main-cont">
    <!-- 左侧模块 -->
    <a-col class="left-wrap" :span="12">
      <NewCapitalHeader
        title="北向资金"
        :data="headerNorthLeft"
        :canUpdate="canUpdate"
        :timestamp="timestamp"
        :hsgtTradeStatus="hsgtTradeStatus"
        v-if="JSON.stringify(headerNorthLeft) !== '{}'"
      />
      <!-- 北向资金分时 -->
      <DataHeader class="wrap-sharing-chart">
        <div slot="title" class="dataHeaderTitle por">
          <div class="date-lr-tab cleaRfix">
            <div  class="title" :class="sharingLeft === 0 ? 'lr-active' : ''" @click="sharingTabChange(0)">
              陆股通成分股资金流向
            </div>
            <Tips :text="text" :width="'500px'"></Tips>
          </div>
          <DropdownIndex name="northShare" />
          <!-- 叠加指数 -->
        </div>
        <div slot="cont" class="dataHeaderCont">
          <!-- 资金分时图 -->
          <FundSharing
            :newShareData="newShareLeft"
            :indexData="indexData"
            name="northShare"
            :plainOptions="['陆股通成分股资金流向', '沪', '深']"
            :sharingTab="sharingLeft"
            :isMainMoney="true"
          />
        </div>
      </DataHeader>

      <!-- 北向资金历史走势 -->
      <DataHeader class="wrap-history-chart" :marginTop="3">
        <div slot="title" class="dataHeaderTitle por">
          <div class="date-lr-tab cleaRfix">
            <div
              class="fl lr-tab-item"
              :class="lractiveLeft === 0 ? 'lr-active' : ''"
              @click="checkoutLr(0)"
            >
              历史净买入
            </div>
            <div
              class="fl lr-tab-item"
              :class="lractiveLeft === 1 ? 'lr-active' : ''"
              @click="checkoutLr(1)"
            >
              累计净买入
            </div>
          </div>
        </div>
        <div slot="cont" class="dataHeaderCont">
          <FundHistory
            name="north"
            :lrActive="lractiveLeft"
            :spaceActive="spaceActiveLeft"
            :options="['北向资金', '沪股通', '深股通']"
          />
        </div>
      </DataHeader>
    </a-col>

    <!-- 右侧模块 -->
    <a-col class="right-wrap" :span="12">
      <CapitalHeader
        title="南向资金"
        :data="headerRight"
        v-if="JSON.stringify(headerRight) !== '{}'"
      />
      <!-- 南向资金分时 -->
      <DataHeader class="wrap-sharing-chart">
        <div slot="title" class="dataHeaderTitle por">
          <div class="date-lr-tab cleaRfix">
            <div
              class="fl lr-tab-sharing-item"
              :class="sharingRight === 0 ? 'lr-active' : ''"
              @click="sharingTabChange(2)"
            >
              净买入
            </div>
            <div
              class="fl lr-tab-sharing-item"
              :class="sharingRight === 1 ? 'lr-active' : ''"
              @click="sharingTabChange(3)"
            >
              净流入
            </div>
          </div>
          <DropdownIndex name="southShare" />
        </div>
        <div slot="cont" class="dataHeaderCont">
          <!-- 资金分时图 -->
          <FundSharing
            :shareData="shareRight"
            :indexData="indexData"
            name="southShare"
            :plainOptions="['南向资金', '港股通（沪）', '港股通（深）']"
            :sharingTab="sharingRight"
            v-if="shareRight.date"
          />
        </div>
      </DataHeader>

      <!-- 南向资金历史走势 -->
      <DataHeader class="wrap-history-chart" :marginTop="3">
        <div slot="title" class="dataHeaderTitle por">
          <div class="date-lr-tab cleaRfix">
            <div
              class="fl lr-tab-item"
              :class="lractiveRight === 0 ? 'lr-active' : ''"
              @click="checkoutLr(2)"
            >
              历史净买入
            </div>
            <div
              class="fl lr-tab-item"
              :class="lractiveRight === 1 ? 'lr-active' : ''"
              @click="checkoutLr(3)"
            >
              累计净买入
            </div>
          </div>
          <DropdownIndex name="south" />
          <ul class="date-spacing poa fr">
            <li
              class="fl"
              v-for="(item, index) in spaceList"
              :key="index"
              :class="spaceActiveRight === index ? 'space-active' : ''"
              @click="checkoutDate('south', index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div slot="cont" class="dataHeaderCont">
          <FundHistory
            name="south"
            :lrActive="lractiveRight"
            :spaceActive="spaceActiveRight"
            :options="['南向资金', '港股通(沪)', '港股通(深)']"
          />
        </div>
      </DataHeader>
    </a-col>
  </a-row>
</template>

<script>
import DataHeader from './dataHeader/dataHeader';
import CapitalHeader from './capitalHeader/capitalHeader';
import NewCapitalHeader from './newCapitalHeader/capitalHeader.vue';
import Tips from './capitalHeader/tips.vue';
import DropdownIndex from './dropdownIndex/dropdownIndex';
import FundSharing from './fundSharing/fundSharing';
import FundHistory from './fundHistory/fundHistory';
import { getHeader, getFs, getShare, getShareLeft } from '../assets/js/action';
import {
  handleHsgtMainMoneyData,
  getForwardNDayTimestampInSeconds,
  getSpecificTimeTimestampInMillisByDateStr,
  getSpecificTimeTimestampInSeconds,
  formateDateByTimestampInSeconds,
} from '../common/utils/handleCaptialFlowChartData.js';
import { post, get } from '../assets/js/request';
import { url, hsgtMainMoneyParams, hsgtTradeStatusParams } from '../assets/js/config';

export default {
  components: {
    DataHeader,
    CapitalHeader,
    NewCapitalHeader,
    DropdownIndex,
    FundSharing,
    FundHistory,
    Tips,
  },
  props: ['theme1'],
  data() {
    return {
      headerLeft: {},
      headerNorthLeft: {
        h: {
          up: '',
          mid: '',
          down: '',
          state: '',
        },
        s: {
          up: '',
          mid: '',
          down: '',
          state: '',
        },
      },
      headerRight: {},
      indexData: {}, // 指数数据
      shareLeft: {},
      newShareLeft: {},
      shareRight: {},
      lractiveLeft: 0,
      lractiveRight: 0,
      sharingLeft: 0,
      sharingRight: 0,
      spaceList: ['日', '周', '月', '季', '年'],
      spaceActiveLeft: 0,
      spaceActiveRight: 0,
      hintTitle: {
        northSharing:
          '北向资金是指从香港流入大陆股市的资金。净流入包含当日成交净买额和当日\n申报未成交的买单金额两部分，计算公式为：净流入 = 当日限额 – 当日余额。',
        northHistory:
          '净买入为北向资金主动性买盘与主动性卖盘的差额，计算公式 ：净买入\n = 买入成交额 – 卖出成交额。累积净买入为对应时间段净买入累计之和。',
        southSharing:
          '南向资金是指从大陆流入香港股市的资金。净流入包含当日成交净买额和当日\n申报未成交的买单金额两部分，计算公式为：净流入 = 当日限额 – 当日余额。',
        southHistory:
          '净买入为南向资金主动性买盘与主动性卖盘的差额，计算公式 ：净买入\n = 买入成交额 – 卖出成交额。累积净买入为对应时间段累计净买入之和。',
      },
      canUpdate: 1,
      timestamp: null, //更新日期，毫秒级时间戳
      hsgtTradeStatus: 0,
      text:'陆股通成分股资金为陆股通指数成分股对应的大单资金净额之和的实时走势，一共有三条走势线，除了陆股通指数成分股资金流向走势线外，还将陆股通成分股分为沪市和深市拟合出相关的两条走势线，沪市走势图为陆股通指数成分股中沪市股票大单资金净额之和的实时走势，深市走势图为陆股通指数成分股中深市股票大单资金净额之和的实时走势，用不同颜色代表，该实时资金流向并非北向资金，仅供用户参考。'
    };
  },
  mounted: async function () {
    await this.gethsgtTradeStatus();
    this.getNewData();
    setInterval(() => {
      if (this.canUpdate) {
        this.gethsgtTradeStatus();
      }
    }, 1000 * 60);
    setInterval(() => {
      if (!this.canUpdate) return;
      setTimeout(() => {
        this.getNewData();
      });
    }, 1000 * 60);
    this.ifUpdateData();
  },
  methods: {
    checkoutLr(index) {
      /*
       * 逐日/累计 tab 切换
       */
      if (index === 0) {
        this.lractiveLeft = 0;
      } else if (index === 1) {
        this.lractiveLeft = 1;
      } else if (index === 2) {
        this.lractiveRight = 0;
      } else {
        this.lractiveRight = 1;
      }
    },
    sharingTabChange(index) {
      if (index === 0) {
        this.sharingLeft = 0;
      } else if (index === 1) {
        this.sharingLeft = 1;
      } else if (index === 2) {
        this.sharingRight = 0;
      } else {
        this.sharingRight = 1;
      }
    },
    checkoutDate(type, index) {
      /*
       * 日/周/年.. 切换
       */
      if (type === 'north') {
        this.spaceActiveLeft = index;
      } else {
        this.spaceActiveRight = index;
      }
    },
    getHeaderData: function (type) {
      /*
       * 获取头部数据
       */
      getHeader(type)
        .then(data => {
          if (type === 'north') {
            this.headerLeft = data.data.data;
            if (this.headerLeft.h !== undefined) {
              this.headerNorthLeft.h.up = this.headerLeft.h.up;
              this.headerNorthLeft.h.mid = this.headerLeft.h.mid;
              this.headerNorthLeft.h.down = this.headerLeft.h.down;
              this.headerNorthLeft.h.state = this.headerLeft.h.state;
            }
            if (this.headerLeft.s !== undefined) {
              this.headerNorthLeft.s.up = this.headerLeft.s.up;
              this.headerNorthLeft.s.mid = this.headerLeft.s.mid;
              this.headerNorthLeft.s.down = this.headerLeft.s.down;
              this.headerNorthLeft.s.state = this.headerLeft.s.state;
            }
          } else {
            this.headerRight = data.data.data;
          }
        })
        .catch(e => {
          console.error(e); // eslint-disable-line
        });
    },
    getFs: async function () {
      /*
       * 获取分时指数数据
       * 16_1A0001: 上证指数
       * 32_399001: 深证成指
       * 32_399006: 创业板指
       * 16_1B0016: 上证50
       */
      this.indexData = await getFs(
        '16_1A0001,32_399001,32_399006,16_1B0016,176_HSI,176_HSLI,176_HSMI,176_HSSI'
      );
    },
    getShareData: function (type) {
      getShare(type).then(data => {
        if (type === 'north') {
          // this.shareLeft = data.data.data;
        } else {
          this.shareRight = data.data.data;
        }
      });
    },
    // 数据取亿为单位并保留两位小数
    formatNorthData: function (data) {
      return Number((data / Math.pow(10, 8)).toFixed(2));
    },

    ifUpdateData: function () {
      var that = this;
      var e = API.createSessionId('external');
      API.use({
        method: 'external.registerEvent',
        data: 'onshow',
        persistent: true,
        sessionId: e,
        callbackName: 'onshow',
        success: function (data) {
          that.canUpdate = data;
          that.getNewData();
        },
      });
    },
    getNewData() {
      this.getHeaderData('north');
      this.getHeaderData('south');
      this.getNewShareLeftData();
      this.getShareData('south');
      this.getFs();
    },

    //根据陆股通交易状态获取指定交易日
    async getTradeDate(state) {
      let dateData = '';
      //获取当天秒级时间戳
      const timestamp = getForwardNDayTimestampInSeconds(0);
      //生成日期字符串
      const date = formateDateByTimestampInSeconds(timestamp, '');
      //获取交易日
      const res = await get(url.tradeDate, {
        date,
        offset: -1,
      });
      if (res && res.data) {
        if (state === 1) {
          //未开盘取上一个交易日
          dateData = res.data[0];
        } else {
          //其他状态取最新交易日
          dateData = res.data[res.data.length - 1];
        }
        return dateData;
      }
      return null;
    },

    //获取沪深股通主力净流入数据
    async getHsgtMainMoney() {
      const tradeDate = await this.getTradeDate(this.hsgtTradeStatus);
      if (tradeDate) {
        const tradeDateTimeStamp = getSpecificTimeTimestampInMillisByDateStr(tradeDate);
        this.timestamp = tradeDateTimeStamp;
        const startTime = getSpecificTimeTimestampInSeconds(tradeDateTimeStamp, 9, 30);
        const endTime = getSpecificTimeTimestampInSeconds(tradeDateTimeStamp, 15, 0);
        hsgtMainMoneyParams.time_range.start = String(startTime);
        hsgtMainMoneyParams.time_range.end = String(endTime);
        const params = hsgtMainMoneyParams;
        const data = await post(url.indexInterval, params);
        return data;
      }
    },

    //获取陆港通主力资金数据
    async getNewShareLeftData() {
      const res = await this.getHsgtMainMoney();
      if (res && res.data) {
        this.newShareLeft = handleHsgtMainMoneyData(res.data.data);
        return;
      }
      this.newShareLeft = 'noData';
    },

    //获取沪深港通交易状态
    async gethsgtTradeStatus() {
      const params = hsgtTradeStatusParams;
      const res = await post(url.indexCommon, params);
      if (res && res.data) {
        const status = res.data.data[0]['values'][0]['value'];
        this.hsgtTradeStatus = status;
        return;
      }
      this.hsgtTradeStatus = 'noData';
    },
  },
};
</script>

<style lang="less" scoped>
.main-cont {
  width: 1365px;
  height: 675px;
  color: #fff;
  margin: 5px 7px 0 0px;
  .left-wrap,
  .right-wrap {
    height: 100%;
    .wrap-header {
      height: 134px;
    }
    .wrap-sharing-chart {
      height: 243px;
      .dataHeaderCont {
        height: 212px;
      }
    }
    .wrap-history-chart {
      height: 293px;
      .dataHeaderCont {
        height: 262px;
      }
    }
  }
  .left-wrap {
    padding-right: 3px;
  }
  .right-wrap {
    padding-left: 3px;
  }
  .dropdown {
    position: absolute;
    top: 5px;
    right: 10px;
  }
  .date-lr-tab {
    display: flex;
    align-items: center;;
    .title{
      margin-right:4px;
    }
    .lr-tab-item,
    .lr-tab-sharing-item {
      width: 75px;
      height: 20px;
      line-height: 18px;
      text-align: center;
      font-size: 12px;
      margin-top: 5px;
      border: 1px solid #313131;
      background: #adadad;
      color: #626161;
      &.lr-active {
        background: #c63031;
        color: #ffffff;
      }
      &:hover {
        cursor: pointer;
      }
    }
    .lr-tab-sharing-item {
      width: 59px;
      height: 19px;
    }
  }
  .date-spacing {
    right: 170px;
    top: 5px;
    width: 100px;
    height: 20px;
    line-height: 18px;
    font-size: 12px;
    color: #666666;
    background: #171b1d;
    li {
      width: 20px;
      height: 20px;
      box-sizing: border-box;
      background-color: #adadad;
      border: 1px solid #313131;
      text-align: center;
      font-size: 12px;
      &.space-active {
        color: #ffffff;
        background: #c63031;
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
  .data-date {
    position: absolute;
    right: 160px;
    font-size: 12px;
    top: 0;
    color: #d2d2d3;
  }
}
.newblack .left-wrap {
  border-right: 1px solid #cbcbe1;
}
.newblack {
  .main-cont {
    width: 1369px;
    border: solid 1px #cbcbe1;
    color: #272841;
    .left-wrap,
    .right-wrap {
      .wrap-sharing-chart {
        border-top: solid 1px #cbcbe1;
      }
      .wrap-history-chart {
        border-top: solid 1px #cbcbe1;
      }
    }
    .date-lr-tab {
      .lr-tab-item,
      .lr-tab-sharing-item {
        border: solid 1px #fff;
        background: #e4e4f2;
        color: #272841;
        &.lr-active {
          background: #2267da;
          color: #fff;
        }
      }
    }
    .date-spacing {
      color: #272841;
      background-color: #e4e4f2;
      li {
        background-color: #e4e4f2;
        border: 1px solid #fff;
        &.space-active {
          color: #ffffff;
          background: #2267da;
        }
      }
    }
  }
}
.newgrey .left-wrap {
  border-right: 1px solid #2e2e33;
}
.newgrey {
  .main-cont {
    width: 1369px;
    border: solid 1px #2e2e33;
    color: #fff;
    .left-wrap,
    .right-wrap {
      .wrap-sharing-chart {
        border-top: solid 1px #2e2e33;
      }
      .wrap-history-chart {
        border-top: solid 1px #2e2e33;
      }
    }
    .date-lr-tab {
      .lr-tab-item,
      .lr-tab-sharing-item {
        border: 1px solid #181c21;
        background: #393941;
        color: #fff;
        &.lr-active {
          background: #1b63d9;
          color: #fff;
        }
      }
    }
    .date-spacing {
      color: #fff;
      background-color: #181c21;
      li {
        background-color: #393941;
        border: solid 1px #181c21;
        &.space-active {
          color: #ffffff;
          background: #1b63d9;
        }
      }
    }
  }
}
</style>
